import lessonTypes from 'helpers/enums/lessonTypes'

export default {
	REGULAR: lessonTypes.REGULAR,
	VIDEO: lessonTypes.VIDEO,
	STANDALONE_ACTIVITIES: lessonTypes.STANDALONE_ACTIVITIES,
}
